import { z } from 'zod';
import type { TypedCubeQuery } from 'shared/src/generated/cube-types';

export const DailyRevenueSpend = z
  .object({
    'line_item_metrics_daily.day': z.string(),
    'line_item_metrics_daily.billable_revenue': z.coerce.number(),
    'line_item_metrics_daily.actual_spend': z.coerce.number()
  })
  .transform(row => ({
    day: row['line_item_metrics_daily.day'].slice(0, 10), // YYYY-MM-DD; Cube returns a full timestamp
    billableRevenue: row['line_item_metrics_daily.billable_revenue'],
    actualSpend: row['line_item_metrics_daily.actual_spend']
  }));

export type DailyRevenueSpend = z.output<typeof DailyRevenueSpend>;

export type BillableRevenueResult = {
  rows: DailyRevenueSpend[];
  isLoading: boolean;
  error: string | undefined;
};

export function billableRevenueQuery(lineItemId: string) {
  return {
    dimensions: ['line_item_metrics_daily.day'],
    measures: ['line_item_metrics_daily.billable_revenue', 'line_item_metrics_daily.actual_spend'],
    order: [['line_item_metrics_daily.day', 'asc']],
    filters: [
      {
        member: 'line_item_metrics_daily.line_item_id',
        operator: 'equals',
        values: [lineItemId]
      }
    ]
  } satisfies TypedCubeQuery<
    readonly ['line_item_metrics_daily.day'],
    readonly ['line_item_metrics_daily.billable_revenue', 'line_item_metrics_daily.actual_spend']
  >;
}
